import React from 'react';

import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { EmptyListLarge as EmptyListLargeIcon } from 'components/icons';

import { Button, Typography } from '../../../components/atoms';

type Props = {
  handleStartOrdering: any;
  translate: any;
};

const useStyles = makeStyles((theme: Theme) => ({
  historyUnavailable: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
  },

  pageContent: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'column nowrap',
    paddingTop: theme.spacing(14),

    '& .fd-text ': {
      margin: theme.spacing(2, 0, 3),
    },
  },

  [theme.breakpoints.up('lg')]: {
    historyUnavailable: {
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(10),
    },
  },
}));

export function HistoryUnavailable(props: Props): JSX.Element {
  const { handleStartOrdering, translate } = props;

  const classes = useStyles();

  return (
    <div className={classes.historyUnavailable}>
      <div className={classes.pageContent}>
        <EmptyListLargeIcon />
        <Typography variant="h3">
          {translate('HistoryPage_NoPreviousOrders_warning')}
        </Typography>
        <Button onClick={handleStartOrdering}>
          {translate('HistoryPage_StartOrdering_button')}
        </Button>
      </div>
    </div>
  );
}
